export default __webpack_public_path__ + "static/media/cocoapods.1488710d.svg";